(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('EditAccountController', EditAccountController);

  /* ngInject */
  function EditAccountController(Flash, accountService, accountUserService, formErrorsService, sessionService, usStates) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.fi = {};
    vm.form = {};
    vm.states = usStates;
    vm.saveFi = saveFi;
    vm.users = [];

    vm.activate();

    function activate() {
      accountService(sessionService.getAuthToken()).get(response => vm.fi = response);
      accountUserService(sessionService.getAuthToken()).query(response => vm.users = response);
    }

    function saveFi() {
      vm.clearFormErrors();
      accountService(sessionService.getAuthToken()).update(vm.fi, _saveFiSuccess, _saveFiFailure);
    }

    function _saveFiSuccess(_response) {
      Flash.create('success', 'Account information successfully updated.');
    }

    function _saveFiFailure(response) {
      Flash.create('danger', 'An error occurred. Please correct the errors on the form below and resubmit.');
      vm.setFormErrors(vm.form, response);
    }
  }
})();
